module.exports = __webpack_public_path__ + "img/wild_table.bda6099a.png";